<template>
	<page enable-flex :style="{'background': scanRack ? '' : '#fff'}">
		<scan ref="scan" name="货架码" :immediate="false" @scan="codeHandle">
			<div class="info flex-wrap">
				<div class="base flex-start-center">
					<label>货架名称：</label>
					<b></b>
				</div>
				<div class="base flex-start-center">
					<label>货架码：</label>
					<b>{{scanRack}}</b>
				</div>
				<div class="total flex-column flex-center">
					<label>预计上货架</label>
					<b>{{nextRack}}</b>
				</div>
				<div class="total flex-column flex-center">
					<label>预计剩余空位</label>
					<b>{{emptyRack}}</b>
				</div>
				<div class="total flex-column flex-center">
					<label>本次累计添加</label>
					<b>{{productList.length}}</b>
				</div>
			</div>

			<div class="product">
				<h1>机器列表</h1>
				<insert-data scan-name="扫背贴码添加机器" @beforeScan="scanValid" @scan="scanHandle"></insert-data>
				<div v-if="productList.length" class="list">
					<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1">
						<template #title>
							<span>{{item.product_name}}</span>
						</template>

						<template #default>
							<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
						</template>
					</detail-card>
				</div>
			</div>
		</scan>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				scanRack: '',
				nextRack: '-',
				emptyRack: '-',
				productList: []
			}
		},
		
		methods: {
			codeHandle(code) {
				this.scanRack = code;
				this.request({
					url: '/electronic/shelf/slots/resolve',
					data: {
						slotCode: code
					},
					success: data => {
						this.nextRack = data.resolvedSlotCode;
						this.emptyRack = data.emptySlotCodes ? data.emptySlotCodes.length : 0;
					},
					fail: () => {
						this.$refs.scan.reset();
					}
				});
			},

			scanValid(stop) {
				if (this.emptyRack <= 0) {
					stop();
					this.$message({
						message: '暂无剩余空位，无法添加机器'
					})
				}
			},

			scanHandle(code) {
				this.request({
					url: '/electronic/shelf/slots/bind',
					data: {
						produceCode: code,
						slotCode: this.nextRack
					},
					loading: true,
					success: data => {
						this.nextRack = data.resolvedSlotCode;
						this.emptyRack = data.emptySlotCodes ? data.emptySlotCodes.length : 0;
						this.productList.push({
							product_name: data.productName,
							produce_unique_code: code
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	>>> .info {
		column-gap: .2rem;
		row-gap: .14rem;
		border-radius: .16rem;
		padding: .18rem;
		margin: .2rem .24rem;
		background: #fff;

		.base {
			box-sizing: border-box;
			width: 3.22rem;
			height: .72rem;
			border-radius: .08rem;
			padding: 0 .22rem;
			font-size: .26rem;
			color: #666;
			background: #F9F9F9;

			b {
				font-size: .3rem;
				color: #000;
			}
		}

		.total {
			gap: .2rem;
			box-sizing: border-box;
			width: 2.08rem;
			height: 1.2rem;
			border-radius: .08rem;
			font-size: .24rem;
			color: #666;
			background: #EFF2FF;

			b {
				font-size: .36rem;
				color: #3D5EFF;
			}
		}
	}

	.product {
		border-radius: .16rem;
		padding: 0 .2rem .2rem;
		margin: 0 .2rem .24rem;
		background: #fff;

		h1 {
			padding: 0 .08rem;
			line-height: .94rem;
			font-size: .32rem;
		}

		.list {
			margin-top: .24rem;
		}
	}
</style>